export default {
    items: [
        {
            name: 'report',
            url: '#',
            // url: '/dashboard',
            icon: 'home',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12],
            children: [
                {
                    name: 'Overview',
                    url: '/overview',
                },
                {
                    name: 'serverShift',
                    url: '/server-shift',
                    permissions: [9, 11, 12]
                },
                {
                    name: 'endOfDay',
                    url: '/end-of-day',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10]
                },
                {
                    name: 'tipSummary',
                    url: '/tip-summary',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10]
                },
                {
                    name: 'SalesInsights',
                    url: '/dashboard',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10]
                },
                {
                    name: 'menuDisplays',
                    url: '/menu-displays',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10]
                },
            ]
        },
        {
            name: 'todayOrders',
            url: '/todayOrders',
            icon: 'list'
        },
        {
            name: 'ticket',
            url: '/todaytickets',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 10],
            icon: 'list'
        },
        {
            name: 'specialEventOrders',
            url: '/specialEventOrders',
            icon: 'list'
        },
        {
            name: 'orderHistory',
            url: '/orderHistory',
            icon: 'clock',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10]
        },
        {
            name: 'createTab',
            url: `/createOrder/index?orderTypeId=${1}`,
            icon: 'plus',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]
        },
        {
            name: 'visuals',
            icon: 'list',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10],
            url: '#',
            parentClass: 'mt-5',
            children: [
        {
            name: 'menuDisplay',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10],
            url: '/Visuals/menuDisplay/',
        },
        {
            name: 'menuBoard',
            url: '/Visuals/menuBoard/',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7]
        },]
        },

        {
            name: 'menuEditor',
            icon: 'edit',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7],
            parentClass: 'my-5',
            url: '#',
            children: [
                {
                    name: 'myMenu',
                    url: '/menueditor/myMenu',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7],
                },
                {
                    name: 'itemAvailabilityControl',
                    url: '/menueditor/itemavailabilty',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7],
                },
                {
                    name: 'modifiers',
                    url: '/menueditor/menuModifiers',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7],
                },
            ],
        },
        

        {
            name: 'settings',
            icon: 'cog',
            permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10],
            url: '#',
            children: [
                {
                    name: 'general',
                    url: '/settings/general',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 10],
                },
                {
                    name: 'pickup',
                    url: '/settings/togo',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]
                },
                {
                    name: 'delivery',
                    url: '/settings/delivery',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]
                },
                {
                    name: 'dineIn',
                    url: '/settings/dinein',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]
                },
                {
                    name: 'loyalty',
                    url: '/settings/loyalty',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]
                },
                
                {
                    name: 'businessProfile',
                    url: '/settings/businessProfile',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7],
                },
                {
                    name: 'users',
                    url: '/settings/users',
                    permissions: [0, 1, 2, 3, 4, 5, 6, 7],
                },
            ]
        },
        

        // {
        //   name: 'users',
        //   url: '/settings/users',
        //   permissions: [0,1,2,3,4,5,6,7],
        // }


    {
      name: 'support',
      url: '#',
      icon: 'envelope',
        children: [
            {
                name: 'contactUs',
                url: '/support',
                // icon: 'envelope',
            },
            {
                name: 'TutorialVideoclips',
                url: '/tutorialVideoclips',
                // icon: 'video',
            },
            {
                name: 'downloads',
                url: '/downloads',
            }
        ]
    },

    // {
    //   name: 'testPrint',
    //   url: '/support/testPrint',
    //   icon: 'print',
    //   permissions: [0,1,2,3,4,5,6,7,8]
    // }
  ]
}
